const { dataLayer } = require("../lib/analytics");

$(document).on("click", ".search-tag", () => {
  dataLayer.push({
    event: "searchTagClick",
  });
});
